import React from "react";
import {
  Tooltip,
  Overlay,
} from "react-bootstrap";


class PersistentTooltip extends React.Component {
  constructor(props) {
    super(props);

    this.attachRef = target => this.setState({ target });
    this.state = {
      show: false,
    };
  }

  updateShowState(show) {
    this.setState({ show });
  }

  render() {
    const { show, target } = this.state;

    return (
      <div id={this.props.id}
        className = {this.props.className || ""}
        style={this.props.style || { display: "inline" } }
        onMouseEnter={() => this.updateShowState(!!this.props.overlay)}
        onMouseLeave={() => this.updateShowState(false)}
        onFocus={() => this.updateShowState(!!this.props.overlay)}
        onBlur={() => this.updateShowState(false)}
        ref={this.attachRef}
      >
        {this.props.children}
        <Overlay target={target} show={show} placement={this.props.placement || "top"}>
          {({ placement, scheduleUpdate, arrowProps, ...props }) => (
            <Tooltip
              className={this.props.overlayClassName}
              placement={this.props.placement || "top"}
              {...props}
              style={{
                opacity: 0.9,
                ...props.style,
              }}>
                {this.props.overlay}
            </Tooltip>
          )}
        </Overlay>
      </div>
    );
  }
}

export default PersistentTooltip;
